<template>
  <div class="visitor-suc">
      <div class="visitor-header">
         <img class="img" src="~@/assets/images/visitorsuc.png" alt="">
         <div class="title">提交成功</div>
      </div>
      <div class="visitor-body">
        <div class="visitor-item">
          <label class="label">提交时间</label>
          <div class="value">{{submitTime}}</div>
        </div>
        <div class="visitor-item">
          <label class="label">健康状况</label>
          <div class="value">{{healthy}}</div>
        </div>
        <div class="visitor-item">
          <label class="label">测量体温</label>
          <div class="value active">{{temperature}}</div>
        </div>
      </div>
      <div class="ad-wrapper">
        <img class="ad-img" src="https://platform-oss.oss-cn-qingdao.aliyuncs.com/window/ad/fangyidibu.png" alt="">
      </div>
  </div>
</template>
<script>
import { formatTime } from '@/utils/index'
export default {
  data () {
    return {
      submitTime: null,
      healthy: '',
      temperature: '',
      healthyArr: ['健康', '咳嗽', '发烧', '乏力', '其他']
    }
  },
  mounted () {
    const { healthyStatus = [], temperature } = this.$route.params
    console.log(this.$route.params)
    this.submitTime = formatTime(new Date())
    this.temperature = temperature || ''
    this.healthy = this.formatHealthy(healthyStatus)
  },
  methods: {
    formatHealthy (arr) {
      let len = arr.length
      let newArr = []
      for (let i = 0; i < len; i++) {
        if (arr[i]) {
          newArr.push(this.healthyArr[i])
        }
      }
      return newArr.join('，')
    }
  }
}
</script>
<style lang="scss" scoped>
.visitor-suc {
  min-height: 100vh;
  background: #f7f7f7;
}
.visitor-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 15px;
  padding: 20px;
  background: #fff;
  .img {
    width: 85px;
    margin: 5px auto 20px;
  }
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 16px;
  }
}
.visitor-body {
  padding: 5px 0;
}
.visitor-item {
  display: flex;
  padding: 12px 15px;
  background: #fff;
  .label {
    white-space: nowrap;
    font-size: 16px;
    color: #666;
  }
  .value {
    flex: 1;
    font-size: 18px;
    color: #666;
    text-align: right;
  }
  .value.active {
    font-size: 18px;
    color: #ff6b23;
    font-weight: bold;
  }
}
.ad-wrapper {
  margin-top: 15px;
}
.ad-img {
  width: 100%;
}
</style>
